<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import Ingredient from "./Ingredient.vue";
import Draggable from "vuedraggable";
const setDragCursor = (value) => {
  const html = document.getElementsByTagName("html").item(0);
  html.classList.toggle("grabbing", value);
};
export default {
  props: ["group"],
  components: {
    Ingredient,
    Draggable,
  },
  data() {
    return {
      isDrag: false,
      items: this.group ? this.group.items : [],
      g_name: this.group ? this.group.name : "",
      timeout: null,
      id: this.group ? this.group.id : null,
      status: this.group ? this.group.status : null,
    };
  },
  methods: {
    ingredientSaved(e) {
      const items = JSON.parse(JSON.stringify(this.items));
      for (let i = 0; i < items.length; i++) {
        const currentItem = items[i];
        if (e.uuid === currentItem.id) {
          items[i].id = e.itemId;
          items[i].ingredient_group = e.ingredient_group;
          items[i].position = e.position;
          items[i].amount = e.amount;
          items[i].note = e.note;
          items[i].ingredient = e.ingredient;
          items[i].unit = e.unit;
          items[i].status = e.added;
        }
      }

      this.$store.commit(`recipes/updateIngredients`, {
        groupId: this.id,
        item: e,
      });

      this.items = items;
    },
    createUpdateIngredientGroup() {
      this.isDrag = false;
      const group = {
        id: this.id,
        g_name: this.g_name,
        group: this.group,
      };

      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (this.status == "create") {
          this.$store
            .dispatch("recipes/createIngredientGroup", group)
            .then((id) => {
              this.id = id;
              this.status = "added";
              this.$store.commit(`commons/setSavingForm`, "Saved");
            });
        } else {
          this.$store
            .dispatch("recipes/updateIngredientGroup", group)
            .then((res) => {
              // // this.makeToast("success", "Success", `Succesfully saved.`);
              this.$store.commit(`commons/setSavingForm`, "Saved");
            });
        }
      }, 1000);
    },
    addIngredient() {
      this.isDrag = false;
      this.$store.commit(
        "recipes/addIngredientToGroupCurrentRecipe",
        this.group.id
      );
    },

    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: `${title || "default"}`,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },
    deleteGroup() {
      this.isDrag = false;
      this.$store.commit("commons/setPreloader", true);
      this.$store
        .dispatch("recipes/deleteIngredientGroup", this.id)
        .then((res) => {
          this.$store.commit(`commons/setSavingForm`, "Deleted");
          this.$store.commit("commons/setPreloader", false);
        });
    },

    onDragStart() {
      setDragCursor(true);
      this.isDrag = true;
    },
    onDragEnd() {
      setDragCursor(false);
    },
  },
  mounted() {
    this.$store.dispatch("recipes/getIngredientItemNumericQuantity");
  },

  computed: {
    ...mapGetters({
      currentIngredient: "recipes/currentIngredient",
    }),
  },
  watch: {
    group(newGroup) {
      const items = JSON.parse(JSON.stringify(newGroup.items));
      console.log(items)
      if (this.currentIngredient.name) {
        for (let i = 0; i < items.length; i++) {
          if (items[i].ingredient == this.currentIngredient.id) {
            items[i].unit = this.currentIngredient.unit_name;
          }
        }
      }

      console.log(items)

      this.items = items;
    },
    items(newItems) {
      setTimeout(() => {
        if (this.isDrag) {
          const newOrder = [];
          for (let i = 0; i < newItems.length; i++) {
            newOrder.push({
              position: i + 1,
              id: newItems[i].id,
            });
          }
          newOrder.forEach((order) => {
            this.$store
              .dispatch("recipes/patchIngredientGroupItem", order)
              .then((res) => {
                this.$store.commit(`commons/setSavingForm`, "Saved");
              });
          });
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.group-header {
  text-transform: uppercase;
  margin-bottom: 1rem;
}
.box-delete {
  display: flex;
  align-items: center;
}
.box-delete input {
  margin-right: 1rem;
}
.table-header {
  display: grid;
  grid-template-columns: 0.5fr 4.6fr 2fr 1fr 3fr 0.5fr;
  gap: 15px;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
}
.auto {
  /* overflow-y: auto;
  max-height: 900px; */
  padding-bottom: 4rem;
}
.auto > div {
  counter-reset: my-awesome-counter;
}
.add-ingredient {
  border-style: dashed;
  text-transform: uppercase;
}
</style>

<template>
  <div>
    <div class="group-header">
      <label>Ingredient Group</label>
      <div class="box-delete">
        <b-form-input
          class="input"
          v-model="g_name"
          @keyup="createUpdateIngredientGroup"
          :id="`ingredient_` + group.id"
        ></b-form-input>
        <b-icon
          icon="trash"
          class="cursor-pointer"
          variant="danger"
          @click="deleteGroup"
        ></b-icon>
      </div>
    </div>

    <div class="table-header" v-if="group.items && group.items.length > 0">
      <div class="column"></div>
      <div class="column">Ingredient</div>
      <div class="column">Amount</div>
      <div class="column">Unit</div>
      <div class="column">Note</div>
      <div class="column"></div>
    </div>
    <div class="auto">
      <draggable v-model="items" @start="onDragStart" @end="onDragEnd">
        <ingredient
          v-for="ingredient of items"
          :key="ingredient.id"
          :ingredient="ingredient"
          :groupId="id"
          @ingredient-saved="ingredientSaved"
        ></ingredient>
      </draggable>
      <div class="auto-add-ingredient">
        <b-button
          variant="outline-success"
          class="add-ingredient"
          block
          @click="addIngredient"
          :disabled="status == 'create'"
          >Add Ingredient</b-button
        >
      </div>
    </div>
    <hr />
  </div>
</template>

